import { Action } from '../actions/geo';

const defaultState = {
  regionCode: undefined,
  countryCode: undefined,
  isFetching: false,
  error: undefined,
  metrosByRegion: {},
  localitiesByArea: {},
  countiesByRegion: {},
};

export default function geoReducer(state = defaultState, action) {
  switch (action?.type) {
    case Action.Geo.FetchSuggestions:
    case Action.Geo.FetchCounties:
    case Action.Geo.FetchMetros:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };

    case Action.Geo.FetchLocalities:
      return {
        ...state,
        isFetchingArea: true,
        area: undefined,
        error: undefined,
      };

    case Action.Geo.FetchLocalitiesCompleted:
      return {
        ...state,
        isFetchingArea: false,
        localitiesByArea: {
          ...state.localitiesByArea,
          [action.meta.key]: action.payload.localities,
        },
        area: action.payload.area || state.area,
      };

    case Action.Geo.FetchLocalitiesFailed:
      return {
        ...state,
        isFetchingArea: false,
        error: action.payload,
      };

    case Action.Geo.FetchSuggestionsCompleted:
      return {
        ...state,
        isFetching: false,
        localitiesByArea: {
          ...state.localitiesByArea,
          [action.meta.key]: action.payload.areas,
        },
      };

    case Action.Geo.FetchSuggestionsFailed:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case Action.Geo.FetchCountiesCompleted:
      return {
        ...state,
        isFetching: false,
        countiesByRegion: {
          ...state.countiesByRegion,
          [action.meta.key]: action.payload.counties,
        },
      };

    case Action.Geo.FetchCountiesFailed:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case Action.Geo.FetchMetrosCompleted:
      return {
        ...state,
        isFetching: false,
        metrosByRegion: {
          ...state.metrosByRegion,
          [action.meta.key]: action.payload.metros,
        },
      };

    case Action.Geo.FetchMetrosFailed:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    case Action.Geo.FetchRegionCompleted:
      return {
        ...state,
        isFetching: false,
        regionCode: action.payload.regionCode,
        countryCode: action.payload.countryCode,
      };

    default:
      return state;
  }
}
